// @flow
import styled, { keyframes } from 'styled-components';

import { pt, px, mb } from 'styled-components-spacing';

import breakpoint from 'styled-components-breakpoint';

import { fontHeadlineDefault, fontCopyDefault } from '@styles/typography';

import theme from '@theme';

// const getMargin = ({ index, imgix }) => {
//   switch (index) {
//     case 1: {
//       return `
//         margin-left: ${imgix ? '-12.5px' : '-9px'};
//         margin-top: -20px;
//         margin-bottom: 20px;
//       `;
//     }
//     case 2: {
//       return 'margin-left: -25px;';
//     }
//     default: {
//       return '';
//     }
//   }
// };

const getMask = ({ index }) => (index % 2 ? 5 : 2);

const getMaskDesktop = ({ index }) => {
  switch (index) {
    case 0: {
      return 2;
    }
    case 1: {
      return 4;
    }
    default: {
      return 3;
    }
  }
};

const transitionRightToLeft = keyframes`
  from {
    right: -100%;
  }
  to {
    right: 0;
  }
`;

const transitionLeftToRight = keyframes`
  from {
    left: -100%;
  }
  to {
    left: 0;
  }
`;

const transitionDownToUp = keyframes`
  from {
    transform: translateY(10%);
  }
  to {
    transform: translateY(0%);
  }
`;

const transitionOpacity = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const StyledCover = styled.div`
  display: block;
`;

export const StyledImageContainer = styled.div`
  visibility: ${({ animate, forceVisible }) => (animate || forceVisible ? 'visible' : 'hidden')};
  ${props => 'index' in props && (props.index % 2 ? 'margin-left: 30px;' : 'margin-right: 30px;')}

  position: relative;
  animation: ${(props) => {
    if (!props.animate) return 'none';
    if (props.index % 2 === 0) return transitionLeftToRight;
    return transitionRightToLeft;
  }}
      0.7s ease-out 1,
    ${({ animate }) => (animate ? transitionOpacity : 'none')} 0.5s ease-in 1;

  ${breakpoint('desktop')`
    margin: 0;
    animation: none;
    animation: ${({ animate }) => (animate ? transitionDownToUp : 'none')} 0.7s ease-out 1, 
      ${({ animate }) => (animate ? transitionOpacity : 'none')} 0.5s ease-in 1;
  `}
  ${breakpoint('mobile', 'desktop')`
  margin: auto;
  img{
    width:380px;
    height:100%;
    min-width:280px;
  }
`}
`;

export const StyledImageCover = styled.div`
  position: relative;
  width: 100%;
`;

export const StyledPath = styled.path`
  display: none;
  ${breakpoint('mobile', 'desktop')`
    &:nth-child(${getMask}) {
      display: block;
    }
  `}
  ${breakpoint('desktop')`
    &:nth-child(${getMaskDesktop}) {
      display: block;
    }
  `}
`;

export const StyledCopy = styled.div`
  ${pt(3.5)};
  ${px(4)};
  ${breakpoint('mobile', 'desktop')`
  ${px(3)};
  }
`}
  display: flex;
  flex-direction: column;
`;

export const StyledCopyHeadlineText = styled.h4`
  ${fontHeadlineDefault}

  ${mb(3)}

  ${theme.typography.Raleway}

  line-height: 30px;

  ${breakpoint('desktop')`
    ${mb(1)}
    min-height: 4.5rem;
    text-align: center;
  `}
`;

export const StyledCopyText = styled.span`
  ${fontCopyDefault};
`;
